var map = {
	"./cs.json": "c686",
	"./de.json": "6ce2",
	"./en.json": "edd4",
	"./es.json": "a306",
	"./fr.json": "f693",
	"./he.json": "ba8d",
	"./it.json": "0825",
	"./kk.json": "2d0f",
	"./old_es.json": "f250",
	"./ru.json": "7704"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "49f8";